import { ModalState } from 'kinetic-angular';
import { AuthState } from '../components/auth';

export const mockData: AuthState = {
	tncUpdated: true,
	privacyPolicyUpdated: true,
	userId: '616f4abc-3caf-4ba0-8e79-5a8743f2d244',
	firstName: 'Priya',
	lastName: 'Renjith',
	email: 'priya.renjith@accenture.com',
	adminEmailId: 'priya.renjith@accenture.com',
	phoneNumber: '(888)009-1111',
	roles: [
		'd37a94b1-71bf-4d13-8f2e-fd1ff2ebdf76'
	],
	customerIds: [
		'1394564',
		'2137935'
	],
	locations: [
		{
			isParentCompany: true,
			companyId: '0061457068',
			companyName: '',
			locationId: '1394564',
			locationName: 'A',
			address: {
				addressLine1: '202 Hamlin Dr',
				addressLine2: '',
				city: 'Pilot Mountain',
				state: 'NC',
				country: 'United States',
				zipCode: '27041-8707'
			}
		},
		{
			isParentCompany: true,
			companyId: '263ACTIS00',
			companyName: 'Actis Manufacturing Ltd., LLC',
			locationId: '2137935',
			locationName: 'ACTIS MANUFACTURING LLC',
			address: {
				addressLine1: '4051 Freeport Pkwy Ste 400',
				addressLine2: '',
				city: 'Grapevine',
				state: 'TX',
				country: 'United States',
				zipCode: '76051-2316'
			}
		}
	],
	adminLocationID: '',
	company: 'ACTIS MANUFACTURING LLC',
	contactGRID: '450678',
	contactID: '',
	primaryLocationGRID: '102659',
	topLevelGrid: ''
};
        
export const mockUserData= {
	success: true,
	message: 'Success',
	statusCode: 200,
	data: {
		userId: '616f4abc-3caf-4ba0-8e79-5a8743f2d244',
		firstName: 'Priya',
		lastName: 'Renjith',
		contactID: '12456',
		email: 'priya.renjith@accenture.com',
		adminEmailId: 'priya.renjith@accenture.com',
		phoneNumber: '(888)009-1111',
		roles: [
			'd37a94b1-71bf-4d13-8f2e-fd1ff2ebdf76'
		],
		customerIds: [
			'1394564',
			'2137935'
		],
		locations: [
			{
				isParentCompany: false,
				companyId: '0061457068',
				companyName: '',
				locationId: '1394564',
				locationName: 'A',
				address: {
					addressLine1: '202 Hamlin Dr',
					addressLine2: '',
					city: 'Pilot Mountain',
					state: 'NC',
					country: 'United States',
					zipCode: '27041-8707'
				}
			},
			{
				isParentCompany: false,
				companyId: '263ACTIS00',
				companyName: 'Actis Manufacturing Ltd., LLC',
				locationId: '2137935',
				locationName: 'ACTIS MANUFACTURING LLC',
				address: {
					addressLine1: '4051 Freeport Pkwy Ste 400',
					addressLine2: '',
					city: 'Grapevine',
					state: 'TX',
					country: 'United States',
					zipCode: '76051-2316'
				}
			}
		]
	}
};
export const mockTmhCorporateAdminData= {
	firstName: 'Priya',
	lastName: 'Renjith',
	email: 'priya.renjith@accenture.com'
};
export const mockCustomeSupportLabels= {
	hidden: true,
	username: 'Subhash V',
	warningNote: 'You are currently viewing the portal as John Doe sees it.',
	readOnly: 'Read Only',
	endSession: 'End Session',
	endSessionNote: 'Are you sure you want to end the session?'
};
export const mockModalState: ModalState = {
	
	closeHidden: true,
	hidden: true,
	label: '',
	cssClass: '',
	buttons: [
		{ label: '', disabled: false, cssClass: 'btn-secondary' },
		{ label: '', disabled: false, cssClass: 'btn-black' }
	],
	tooltip: {
		closeIcon: {
			iconPath: '',
			altText: ''
		},
		content: ''
	}
};

export const mockPrivacy = {
	updatedPrivacy: {
		agreeButtonLabel: '',
		heading: '',
		content: [],
		disagreeButtonLabel: '',
		creationDate: 0,
		infoIcon: [{
			iconPath: '',
			altText: ''
		}]

	}
};
export const mockTerms = {
	updatedTerms: {
		agreeButtonLabel: '',
		heading: '',
		content: [],
		disagreeButtonLabel: '',
		creationDate: 0,
		infoIcon: [{
			iconPath: '',
			altText: ''
		}]

	}
};

